import {GlobalUtility} from '../../../service/global-utility.service';
import {BED} from '../../../service/constants.service';

import axios from 'axios';
import {AlertsService} from '../../../service/alerts.service';

const state = {
  bed:{},
  beds:[],
  newBed : {
    //properties here.
    status : '',
    hotel_id : '',
    floor_id : '',
    room_id : '',
  }
};


const mutations = {
  set_bed : (state,param) =>{
    //view bed
    state.bed = param;
  },

  set_beds : (state,params) =>{
    state.beds = params;
  },

  set_new_bed : (state,params) =>{
    //create
    state.beds.push(params);
    state.newBed = {
      status : '',
      hotel_id : '',
      floor_id : '',
      room_id : '',
    }
  },

  set_update_bed : (state,param) =>{
    //update
    let bed = state.beds.find(bed => bed.id === param.id);
    Object.assign(bed,param);
  },

  set_delete_bed : (state,param) =>{
    let index = state.beds.findIndex((index,key)=> index.id === param.id);
    state.beds.splice(index,1);
  },

  set_null_bed : (state) =>{
    state.beds = [];
    state.bed = {};
  }
};



const actions = {

  getBeds({commit},param) {
    return axios.get(BED).then((response)=>{
      commit('set_beds',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Beds');
      return false;
    });
  },

  viewBed({commit},param){
    return axios.get(`${BED}/${param.id}`).then((response)=>{
      commit('set_bed',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Bed');
      return false;
    });
  },

  createBed({commit},param){
    return axios.post(BED,param).then((response)=>{
      commit('set_new_bed',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Create Bed');
      return false;
    });
  },

  updateBed({commit},params){
    //bed
    return axios.put(`${BED}/${params.id}`,params).then((response)=>{
      commit('set_update_bed',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Update Bed');
      return false;
    });
  },

  deleteBed({commit},param){
    return axios.delete(`${BED}/${param}`).then((response)=>{
      //todo
      commit('set_delete_bed',response.data);
      return true;
    }).catch((error)=>{
      //todo
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Delete Bed');
      return false;
    });
  },

  setNullBed({commit}){
    commit('set_null_bed');
  }

};


const getters = {
  bed : state => state.bed,
  beds : state => state.beds,
  newBed : state => state.newBed,
};


export default {state,actions,mutations,getters};
